import VisitasDomiciliares from '../pages/VisitasDomiciliares/VisitasDomiciliares'
import FamiliasVisitadas from '../pages/VisitasDomiciliares/FamiliasVisitadas/FamiliasVisitadas'
import FamiliasVisitadasPorEquipeAcs from '../pages/VisitasDomiciliares/FamiliasVisitadas/PorEquipeAcs'
import FamiliasVisitadasPorProfissional from '../pages/VisitasDomiciliares/FamiliasVisitadas/PorProfissional'
import CidadaosVisitados from '../pages/VisitasDomiciliares/CidadaosVisitados/CidadaosVisitados'
import CidadaosVisitadosPorEquipeAcs from '../pages/VisitasDomiciliares/CidadaosVisitados/PorEquipeAcs'
import CidadaosVisitadosPorAcs from '../pages/VisitasDomiciliares/CidadaosVisitados/PorAcs'
import VisitasNoMes from '../pages/VisitasDomiciliares/VisitasNoMes/VisitasNoMes'

export default [
  {
    path: '/visitas-domiciliares',
    component: VisitasDomiciliares
  },
  {
    path: '/familias-visitadas',
    component: () =>
      import('@/pages/VisitasDomiciliares/FamiliasVisitadas/Template.vue'),
    children: [
      {
        path: '/familias-visitadas',
        component: FamiliasVisitadas
      },
      {
        path: '/familias-visitadas/equipe/acs',
        component: FamiliasVisitadasPorEquipeAcs
      },
      {
        path: '/familias-visitadas/profissional',
        component: FamiliasVisitadasPorProfissional
      }
    ]
  },
  {
    path: '/cidadaos-visitados',
    component: () =>
      import('@/pages/VisitasDomiciliares/CidadaosVisitados/Template.vue'),
    children: [
      {
        path: '/cidadaos-visitados',
        component: CidadaosVisitados
      },
      {
        path: '/cidadaos-visitados/equipe/acs',
        component: CidadaosVisitadosPorEquipeAcs
      },
      {
        path: '/cidadaos-visitados/acs',
        component: CidadaosVisitadosPorAcs
      }
    ]
  },
  {
    path: '/visitas-no-mes',
    component: VisitasNoMes
  },
  {
    path: '/desempenho-por-acs',
    component: () =>
      import('@/pages/VisitasDomiciliares/DesempenhoPorAcs/Template.vue'),
    children: [
      {
        path: '/desempenho-por-acs',
        component: () =>
          import('@/pages/VisitasDomiciliares/DesempenhoPorAcs/Index.vue')
      },
      {
        path: '/desempenho-por-acs/profissional',
        component: () =>
          import(
            '@/pages/VisitasDomiciliares/DesempenhoPorAcs/Profissional.vue'
          )
      }
    ]
  }
]
